import {Injectable} from '@angular/core';
import {EncrDecrService} from './encr-decr.service';

declare let angular: any;

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private memoryCache: Map<string, any> = new Map<string, any>();

  constructor(
    private encryptDecrypt: EncrDecrService) {
  }
  // Note 20210209 rlp - this looks odd, but the orig app made extensive use of localstorage as a local cache. bad idea.
  // i hijacked it here to implement a new shared data via service. just allows the old code in each ts to
  // be changed by attrition and still works as is. when we work on a ts with localstorage fix the code.
  // we can still cache big sets to shared data - just make the adjustments here - setup a var in storage
  // and mod add - get here.
  // add as may values to the service as we needed. make objects where it makes sense to aggregate.

  // *** NOTE *** permissions, preferences, and token are in auth service and saved as encrypted from there.

  StorageSet(aKey: string, aValue: any): void {
    if (aKey === 'Permissions'
      || aKey === 'Preferences'
      || aKey === 'token'
      || aKey === 'uId'
      || aKey === 'uName'
      || aKey === 'uDb'
      || aKey.startsWith('trend')) {
      localStorage.setItem(aKey, aValue);
    } else {
      this.memoryCache.set(aKey, aValue);
    }
  }

  StorageGet(aKey: string, aDefaultValue: any = null): any {
    if (aKey === 'Permissions'
      || aKey === 'Preferences'
      || aKey === 'uId'
      || aKey === 'uName'
      || aKey === 'uDb'
      || aKey === 'token'
    ) {
      if (aKey === 'token') {
        return localStorage.getItem(aKey);
      }
      return this.encryptDecrypt.decrypt(localStorage.getItem(aKey));
    } else {
      return this.memoryCache.get(aKey) ?? aDefaultValue;
    }
  }

  Clear() {
    localStorage.clear();
    sessionStorage.clear();
    this.memoryCache.clear();
  }

  ClearKey(aKey: string){
    localStorage.removeItem(aKey);
  }
}

